import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import supplierEnterpriseObject from "../../assets/supplierEnterpriseObject.png";
import supplierRevisionEnterpriseObject from "../../assets/supplierRevisionEnterpriseObject.png";

export default function Suppliers() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Suppliers</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>REST APIs support the handling of suppliers in Enlil.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>In Enlil, suppliers are documents whose document type group attribute is set to "SUPPLIER". This family of APIs allows for the retrieval, creation and updating of parts.</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for supplier is detailed below. Other Enlil entities (Equipment, Material, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={supplierEnterpriseObject} alt={"Model"}/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>The Enterprise Object Model for Supplier Revisions is detailed below. Other Enlil entities (Equipment Revision, Part Revision, etc.) have a similar Enterprise Object Model.</p>
            <br/>
            <img src={supplierRevisionEnterpriseObject} alt={"Model"}/>
        </div>
    )
}